import produce from 'immer';

// id
import uuid from 'uuid';

// types
import SuggestionTypes from '~/constants/types/SuggestionsTypes';

export function initialState() {
  return {};
}

export default function suggestions(state = initialState(), action) {
  switch (action.type) {
    case SuggestionTypes.CREATE: {
      const payload = action.payload;
      return produce(state, draft => {
        const newId = uuid.v4();
        draft[newId] = {
          id: newId,
          ...payload
        };
      });
    }
    case SuggestionTypes.UPDATE: {
      const payload = action.payload;
      const {id} = payload;

      return produce(state, draft => {
        const currentState = state[id];
        draft[id] = {
          ...currentState,
          ...payload
        };
      });
    }
    case SuggestionTypes.CLEAR_ALL: {
      return initialState();
    }
    default:
      return state;
  }
}
